<section class="banner">
  <div #air id="air" class="air"></div>
  <!-- kenburns-top -->
  <app-nav class="w-100"></app-nav>
  <!-- Search Section -->
  <div class="head-component-ui">
    <div class="searchbar" data-aos="fade-down">
      <div class="hometitle mob-view">
        <div>
          <span class="sstarabicbold text-mobile-size search-txt">
            {{ "Knowledge portal" | translator }}
          </span>
          <span class="sstarabicbold">
            <div class="pi pi-times-circle" routerLink="/home" style="cursor: pointer"></div>

            <i class="pi pi-file-edit me-2 p-1" style="font-size: 2rem" aria-hidden="true"></i>
            {{ "Training Programs" | translator }}
          </span>
        </div>
        <div class="mob-my-2">
          <ng-container *ngIf="addTrainingProgram == false">
            <!-- <button pButton pRipple label="{{ 'Discuss' | translator }}" (click)="getTrainingPrograms()"
              icon="pi pi-search" class="m-1 color-purple"></button>
            <button pButton pRipple label="{{ 'Reset' | translator }}" (click)="refresh()" icon="pi pi-refresh"
              class="m-1 color-purple"></button> -->
            <button *ngIf="hasPermission('TRAINING_PROGRAM','c')" pButton pRipple
              label="{{ 'Add Training Program' | translator }}" (click)="addTrainingProgram = true" icon="pi pi-plus"
              class="m-1 rgb-bg color-purple"></button>
          </ng-container>

          <button *ngIf="addTrainingProgram == true" pButton pRipple label="{{ 'Cancel' | translator }}"
            (click)="addTrainingProgram = false" icon="fa-regular fa-circle-xmark" class="m-1 v4-btn-red py-2"></button>
        </div>
      </div>

      <div class="">
        <div class="" style="position: relative">
          <!-- form data => (ngSubmit)="handleSubmit($event)" -->
          <span class="p-input-icon-right w-100">
            <i class="pi pi-search" style="margin-right: 10px; width: 30px"></i>
            <!-- input data => [(ngModel)]="searchFilterValue" (ngModelChange)="handleFilter('SEARCH',searchFilterValue)" -->
            <input pInputText name="search" [(ngModel)]="searchText"
              class="form-control header-input-ui form-control-lg px-5 shadow-sm sstarabicbold"
              (keydown.enter)="getTrainingPrograms()" type="text" dir="rtl" placeholder="{{ 'Discus' | translator }}" />
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- skelition   -->
  <app-skelitions [hidden]="!skelition" [value]="8" class="mb-2"></app-skelitions>
  <!-- skelition  END -->

  <div [hidden]="skelition" class="container-fluid">
    <div [hidden]="!showFilters" class="container bg-rgb mb-3 mt-4">
      <div class="flex-wrap my-2 px-3">
        <div class="d-flex justify-content-between col-bg mob-column px-2">
          <div class="d-flex flex-wrap w-100">
            <ng-container *ngIf="addTrainingProgram == false">
              <div>
                <h4 class="px-2 my-2">
                  <b class="border-botom"><i class="pi pi-check-square v4-ml-2"></i>{{ "the condition" | translator
                    }}</b>
                </h4>
              </div>
              <div class="mob-my-2 v4-active-2 w-100">
                <p-selectButton class="v4-active-2" [options]="statusOptions" [(ngModel)]="logStatus"
                  optionLabel="arabic" optionValue="name" (onChange)="getTrainingPrograms()"></p-selectButton>
              </div>
            </ng-container>
            <ng-container *ngIf="addTrainingProgram == true">
              <div>
                <h4 class="mb-0 px-2 mt-10">
                  <b class="border-botom"><i class="fa-solid fa-file-circle-plus mx-2"></i>
                    {{ "Add Training Program" | translator }}</b>
                </h4>
              </div>
            </ng-container>
          </div>

        </div>
        <label *ngIf="!addTrainingProgram" class="border-botom">
          <h4>
            <b><i class="pi pi-filter mx-2"></i>{{ "Training Filters" | translator }}</b>
          </h4>
        </label>
        <!-- Service Filter -->
        <div *ngIf="!addTrainingProgram" class="row d-flex my-2">
          <!-- <div class="col-md-4 col-12 my-1">
            <p-dropdown [options]="ouTypes" [(ngModel)]="typeFilter" placeholder="{{ 'Choose Type' | translator }}"
              [filter]="true" styleClass="md:mb-0 sstarabic w-100" class="ppp-dropdown">
              <ng-template let-item pTemplate="item">
                <i [ngClass]="item.icon"></i>
                {{ item.label }}
              </ng-template>
            </p-dropdown>
          </div> -->

          <div class="col-md-8 col-12 my-1">
            <p-treeSelect class="v4-tree w-md-20rem w-100 ppp-tree-select" containerStyleClass="w-100"
              [(ngModel)]="oufilter" [options]="selectedTreeData" appendTo="body"
              placeholder="{{ 'Choose the organizational unit' | translator }}" [filter]="true"
              [filterInputAutoFocus]="true">
              <ng-template let-node pTemplate="default">
                <div class="d-flex">
                  <img *ngIf="checkisImg(node.data); else elseBlock" src="{{ staticURL }}{{ node.data }}"
                    class="img-fluid p-1 tree-img-bg" style="max-height: 30px; max-width: 30px" />
                  <ng-template #elseBlock>
                    <i class="{{ node.data }} p-2" style="font-size: 1rem"></i>
                  </ng-template>
                  <b class="text-nowrap">{{ node.label }}</b>
                </div>
              </ng-template>
            </p-treeSelect>
          </div>
          <div class="col-md-4 col-12">
            <div class="mob-my-2">
              <ng-container *ngIf="addTrainingProgram == false">
                <button pButton pRipple label="{{ 'Discuss' | translator }}" (click)="getTrainingPrograms()"
                  icon="pi pi-search" class="m-1 color-purple"></button>
                <button pButton pRipple label="{{ 'Reset' | translator }}" (click)="refresh()" icon="pi pi-refresh"
                  class="m-1 color-purple"></button>
              </ng-container>
            </div>
          </div>
        </div>
        <!-- End Service Filter -->
        <!-- Log Filter -->
        <div *ngIf="!addTrainingProgram" class="d-flex flex-wrap">
          <div class="column mob-web-mx margin-mob mob-width">
            <div>
              <p class="">
                <b class="border-botom"><i class="pi pi-calendar-plus mx-2"></i>{{ "starting date" | translator }}</b>
              </p>
            </div>
            <div class="v4-calander">
              <p-calendar class="v4-calander" [(ngModel)]="start_date" dir="ltr" [showIcon]="true"></p-calendar>
            </div>
          </div>
          <div class="column mob-web-mx margin-mob mob-width">
            <div>
              <p class="">
                <b class="border-botom"><i class="pi pi-calendar-minus mx-2"></i>{{ "Expiry date" | translator }}</b>
              </p>
            </div>
            <div class="v4-calander">
              <p-calendar class="v4-calander" [(ngModel)]="end_date" dir="ltr" [showIcon]="true"></p-calendar>
            </div>
          </div>

          <!-- <div class="column mob-web-mx margin-mob mob-width">
              <div>
                <p class="mt-3 px-2">
                  <b class="border-botom"
                    ><i class="fa-solid fa-user-pen v4-ml-2"></i
                    >{{ "Request before" | translator }}</b
                  >
                </p>
              </div>
              <div class="v4-active">
                <p-dropdown
                  class="v4-dropp"
                  [options]="contentUpdateUsers?.updated_by"
                  [(ngModel)]="updatedBy"
                  [filter]="true"
                  filterBy="name"
                  [editable]="true"
                  optionLabel="name"
                ></p-dropdown>
              </div>
            </div>
  
            <div class="column mob-web-mx margin-mob mob-width">
              <div>
                <p class="mt-3 px-2">
                  <b class="border-botom"
                    ><i class="fa-solid fa-user-check v4-ml-2"></i
                    >{{ "Approved by" | translator }}</b
                  >
                </p>
              </div>
              <div class="v4-active">
                <p-dropdown
                  class="v4-dropp"
                  [options]="contentUpdateUsers?.approved_by"
                  [(ngModel)]="approvedBy"
                  [filter]="true"
                  filterBy="name"
                  [editable]="true"
                  optionLabel="name"
                ></p-dropdown>
              </div>
            </div> -->

          <!-- <div class="column margin-mob mob-width">
              <div>
                <p class="mt-3 px-2">
                  <b class="border-botom"
                    ><i class="pi pi-sitemap mx-2"></i
                    >{{ "Type" | translator }}</b
                  >
                </p>
              </div>
              <div class="v4-active">
                <p-selectButton
                  class="v4-active"
                  [options]="typeOptions"
                  [(ngModel)]="logType"
                  optionLabel="arabic"
                  optionValue="name"
                ></p-selectButton>
              </div>
            </div> -->

          <!-- <div class="column mob-web-mx margin-mob mob-width">
              <div>
                <p class="mt-3">
                  <b class="border-botom"
                    ><i class="fa-solid fa-download mx-2"></i
                    >{{ "Download" | translator }}</b
                  >
                </p>
              </div>
              <div class="v4-calander">
                <button class="excel-button v4-py" (click)="exportExcel()">
                  <i class="fa-regular fa-file-excel mx-2"></i>
                  <p-progressSpinner
                    class="v4-spin"
                    *ngIf="downloadExcel"
                    ariaLabel="loading"
                  ></p-progressSpinner>
                </button>
              </div>
            </div> -->
        </div>
        <!-- End Log Filter -->
      </div>
    </div>

    <!-- Training Content -->
    <ng-container *ngIf="!addTrainingProgram">
      <!-- stats container -->
      <!-- <div class="container">
             <div *ngIf="totalRecords" class="row">
               <div class="col-md-2 col-12 flex-row">
                 <h5 class="text-light">{{ "Total Records" | translator }}</h5>
                 <div class="row">
                   <div
                     class="col v4-bg rounded p-3 m-2 text-center align-items-center"
                     style="height: 120px"
                   >
                     <h1>{{ totalRecords }}</h1>
                   </div>
                 </div>
               </div>
       
               <div
                 *ngIf="contentstats_data_types?.length > 0"
                 class="col-md-4 col-12 flex-row"
               >
                 <h5 class="text-light">{{ "data types" | translator }}</h5>
                 <div class="row">
                   <div
                     *ngFor="let type of contentstats_data_types"
                     style="height: 120px"
                     class="col v4-bg rounded p-3 m-2 text-center align-items-center"
                   >
                     <p>
                       {{ type._id ? type._id : ("Deleted data type" | translator) }}
                     </p>
                     <h5>{{ type.count }}</h5>
                   </div>
                 </div>
               </div>
       
               <div
                 *ngIf="contentstats_types?.length > 0"
                 class="col-md-6 col-12 flex-row"
               >
                 <h5 class="text-light">{{ "Content Update Type" | translator }}</h5>
       
                 <div class="row">
                   <div
                     *ngFor="let type of contentstats_types"
                     style="height: 120px"
                     class="col v4-bg rounded p-3 m-2 text-center align-items-center"
                   >
                     <p>{{ type._id | translator }}</p>
                     <h5>{{ type.count }}</h5>
                   </div>
                 </div>
               </div>
             </div>
           </div> -->
      <div class="container-fluid mob-bottom-p max-tpv-width" style="transform: scale(0.95, 0.95)">
        <div [hidden]="skelition" class="row p-bottom">
          <span [hidden]="data?.length > 0">
            <!-- <app-no-data [hidden]="data?.length > 0"></app-no-data> -->
            <div [hidden]="data?.length > 0" class="container-fluid">
              <div class="container d-flex justify-content-center">
                <h5 class="la-tujad">
                  {{ "There is no data" | translator
                  }}<i class="pi pi-fw pi-exclamation-triangle font-2rem mx-2"></i>
                </h5>
              </div>
            </div>
          </span>
          <!-- scroll view -->
          <div [ngClass]="{
              'col-lg-4 col-md-4 col-12 fixed-column slide-right': side_view,
              'col-lg-12 col-md-12 col-12': !side_view
            }">
            <span *ngIf="data?.length > 0" class="d-flex align-items-center white-head-box">
              <img class="svg-icon-heading" src="../../../../../assets/v-4-icone/Layer-2.svg" alt="loading" />

              <h5 class="heading mx-2">
                {{ logStatus_set | translator }}
                <!-- {{ "update requests" | translator }} -->
              </h5>
            </span>
            <div class="{{ side_view ? 'v4-height' : '' }}">
              <div class="{{ side_view ? 'v4-scroll' : '' }}">
                <div *ngFor="let log of data" class="{{
                    log._id == selectedViewId
                      ? 'logs-box'
                      : 'log-default'
                  }}">
                  <!-- Edit Log -->
                  <span>
                    <!-- <span class="flex-align-flex mt-2">
                      <img
                        class="svg-icon"
                        src="../../../../../assets/v-4-icone/Layer1.svg"
                        alt="loading"
                      />
                      <span class="color-bold mx-2">{{
                        "Release" | translator
                      }}</span>
                    </span> -->
                    <span>
                      <p-accordion class="v4-accordian" (onOpen)="openLog(log)" (onClose)="openLog(log)" class="w-full">
                        <p-accordionTab class="my-3 v4-accordian">
                          <ng-template pTemplate="header" class="v4-accordian">
                            <div class="container-fluid flex-mob-web">
                              <div class="d-flex">
                                <!-- <i
                                  [ngClass]="
                                    log?.before?.dataview.type?.icon +
                                    ' font-1_2rem'
                                  "
                                  class="m-2"
                                ></i> -->
                                <span class="vertical-align-middle font-1_1rem d-flex">{{ log.title }}</span>
                              </div>
                              <div class="mob-mr d-flex">
                                <span class="tabel-circle-btn m-1">
                                  <i *ngIf="hasPermission('TRAINING_PROGRAM','u')" pTooltip='{{"Edit"| translator}}'
                                    (click)="updateTrainingProgram(log)" tooltipPosition="top"
                                    class="pi pi-file-edit"></i>
                                </span>
                                <span *ngIf="log.status == 'PENDING' && hasPermission('PROGRAM_PUBLISH','a')"
                                  class="tabel-circle-btn m-1">
                                  <i pTooltip='{{"Publish"| translator}}' (click)="confirmApprove(log)"
                                    tooltipPosition="top" class="pi pi-megaphone"></i>
                                </span>
                                <!-- <span class="mx-2">({{ log.createdAt | date }})</span> -->
                              </div>
                            </div>
                          </ng-template>
                          <!-- Training Program Description-->
                          <ng-template pTemplate="content">
                            <div>
                              <span class="color-bold"><i class="pi pi-pencil mx-2"></i>{{ "Description" | translator
                                }}&nbsp;:&nbsp; </span>
                              {{ log.description }}
                            </div>
                            <!-- End Training Program Description-->

                          </ng-template>
                        </p-accordionTab>
                      </p-accordion>
                      <!-- Trainings -->

                      <!-- End Trainings -->
                    </span>
                    <span>
                    </span>
                  </span>





                  <!-- <hr />
                  <div class="mx-3">
                    <h6>
                      <b class="color-bold"
                        ><i class="pi pi-exclamation-circle mx-2 color-bold"></i
                        >{{ "Reason" | translator }}</b
                      >
                    </h6>
                    <span
                      class="v4-color-white"
                      [innerHTML]="log.reason | safeHTML"
                    ></span>
                  </div>

                  <hr /> -->

                  <!-- <div class="mx-3" *ngIf="log.status == 'REJECTED'">
                    <h6>
                      <b class="color-bold">{{
                        "the reason of refuse" | translator
                      }}</b>
                    </h6>
                    <span
                      class="v4-color-white"
                      [innerHTML]="log.reject_reason | safeHTML"
                    ></span>
                  </div> -->



                  <div class="row">
                    <!-- <div class="col-md-8 col-12 p-0">
                      <div class="flex align-items-center">
                        <span>
                          <h6>
                            <b class="color-bold"
                              ><i class="pi pi-user-edit mx-2 color-bold"></i>
                              {{ "Request before" | translator }} :
                            </b>
                            <span class="v4-color-white">
                              {{ log.updated_by.name.first }}
                              {{ log.updated_by.name.middle }}
                              {{ log.updated_by?.name?.last }}
                            </span>
                          </h6>
                          <h6>
                            <b class="color-bold"
                              ><i
                                class="fa-solid fa-envelope mx-2 color-bold"
                              ></i>
                              {{ "Email" | translator }} :
                            </b>
                            <span class="v4-color-white">
                              {{ log.updated_by?.email }}
                            </span>
                          </h6>
                          <h6>
                            <b class="color-bold"
                              ><i
                                class="fa fa-solid fa-phone mx-2 color-bold"
                              ></i>
                              {{ "Phone Number" | translator }} :
                            </b>
                            <span class="v4-color-white">
                              {{ log.updated_by?.phone }}
                            </span>
                          </h6>
                          <h6>
                            <b class="color-bold"
                              ><i
                                class="fa fa-solid fa-location-dot mx-2 color-bold"
                              ></i>
                              {{ "City" | translator }} :
                            </b>
                            <span class="v4-color-white">
                              {{ log.updated_by?.location?.name }}
                            </span>
                          </h6>
                        </span>

                        <span *ngIf="log?.status != 'PENDING'">
                          <h6>
                            <b class="color-bold"
                              ><i class="fa-solid fa-user-check mx-2"></i>
                              <span
                                class="v4-color-white"
                                *ngIf="log?.status == 'APPROVED'"
                                >{{ "Approved by" | translator }} :</span
                              >
                              <span
                                class="v4-color-white"
                                *ngIf="log?.status != 'APPROVED'"
                                >{{ "Rejected before" | translator }} :</span
                              >
                            </b>
                            <span class="v4-color-white">
                              {{ log?.approved_by?.name?.first }}
                              {{ log?.approved_by?.name?.middle }}
                              {{ log?.approved_by?.name?.last }}
                            </span>
                          </h6>

                          <h6>
                            <b class="color-bold"
                              ><i
                                class="fa-solid fa-envelope mx-2 color-bold"
                              ></i>
                              {{ "Email" | translator }} :
                            </b>
                            <span class="v4-color-white">
                              {{ log.approved_by?.email }}
                            </span>
                          </h6>
                          <h6>
                            <b class="color-bold"
                              ><i
                                class="fa fa-solid fa-phone mx-2 color-bold"
                              ></i>
                              {{ "Phone Number" | translator }} :
                            </b>
                            <span class="v4-color-white">
                              {{ log.approved_by?.phone }}
                            </span>
                          </h6>
                          <h6>
                            <b class="color-bold"
                              ><i
                                class="fa fa-solid fa-location-dot mx-2 color-bold"
                              ></i>
                              {{ "City" | translator }} :
                            </b>
                            <span class="v4-color-white">
                              {{ log.approved_by?.location?.name }}
                            </span>
                          </h6>
                        </span>

                        <h6 *ngIf="log?.status != 'PENDING'">
                          <b class="color-bold">
                            <i class="pi pi-calendar-plus mx-2"></i>
                            <span *ngIf="log?.status == 'APPROVED'">
                              {{ "approval date" | translator }} :
                            </span>
                            <span *ngIf="log?.status != 'APPROVED'">
                              {{ "Date of rejection" | translator }} :
                            </span>
                          </b>
                          <span class="v4-color-white">
                            {{ log?.updatedAt | date }}
                          </span>
                        </h6>
                      </div>
                    </div> -->
                    <!-- <div
                      *ngIf="log?.status == 'PENDING' && hasPermission()"
                      class="col-md-12 col-12 d-flex justify-content-end px-3 my-2"
                    >
                      <button class="v4-mini-btn">
                        <i
                          (click)="confirmApprove(log)"
                          class="pi pi-check"
                        ></i>
                      </button>
                      <button class="v4-mini-btn">
                        <i (click)="confirmReject()" class="pi pi-times"></i>
                      </button>
                    </div> -->
                  </div>
                  <!-- End Edit Log -->

                </div>
              </div>

              <div class="mb-5 v4-pagination">
                <p-paginator class="v4-pagination" [hidden]="data?.length <= 0" (onPageChange)="onPageChange($event)"
                  [first]="first" [rows]="rows" [totalRecords]="totalRecords"
                  [rowsPerPageOptions]="[10, 20, 30]"></p-paginator>
              </div>
            </div>
          </div>

          <!-- View Of the Service   'sticky-column': isScrolled && !showFilters,
                   'filter-stickey': isScrolled && showFilters  [ngClass]="{ 'sticky-content': isScrolled }"-->
          <div *ngIf="side_view" #scrollTarget id="topClass" [ngClass]="{
                   'col-lg-8 col-md-8 col-12  slide-left': side_view,
                   'class-for-false': !side_view,
                 
                 }" class="mob-top-wiew" [style.top]="topValue + 'px'"
            style="position: absolute !important; left: 0px !important">
            <div>
              <span class="d-flex align-items-center white-head-box">
                <img class="svg-icon-heading" src="../../../../../assets/v-4-icone/Layer-3.svg" alt="loading" />
                <h5 class="heading mx-2">
                  {{ "Training Program Details" | translator }}
                </h5>
              </span>
              <div class="{{
                  logStatus_set == 'PENDING' || logStatus_set == 'APPROVED'
                    ? 'logs-box-view w-100'
                    : 'log-default w-100'
                }}">
                <div class="row my-2 d-flex align-items-center">
                  <div class="col-md-12 col-12">
                    <div class="d-flex my-2">
                      <div class="column pos-rel w-100">
                        <h4 class="card-title mx-2" style="font-weight: 500; color: white">
                          <i class="fa-solid pi-fw fa-chalkboard v4-ml-2"></i>{{ side_view?.title }}
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>



                <div class="overflow-ui">
                  <!-- start date -->
                  <div class="program-flexx">
                    <div class="cust-flex">
                      <span class="btn-flex mx-1 my-2">
                        <span class="d-flex flex-column">
                          <span class="btn-css mx-2">{{"Start Date" | translator}}</span>
                          <span class="btn-css mx-2 font-0_8rem font-weight-200">
                            {{ side_view?.start_date?.substring(0,10) }}
                          </span>
                        </span>
                        <span class="icon-box cccc">
                          <i class="pi pi-calendar-plus font-500"></i>
                        </span>
                      </span>
                    </div>
                    <div class="cust-flex">
                      <span class="btn-flex mx-1 my-2">
                        <span class="d-flex flex-column">
                          <span class="btn-css mx-2">{{ "End Date" | translator }}</span>
                          <span class="btn-css mx-2 font-0_8rem font-weight-200">
                            {{ side_view?.end_date?.substring(0,10) }}
                          </span>
                        </span>
                        <span class="icon-box cccc">
                          <i class="pi pi-calendar-minus font-500"></i>
                        </span>
                      </span>
                    </div>
                  </div>
                  <!-- end date -->

                  <!-- breadcrumb -->
                  <!-- <div class="d-flex flex-row align-items-center wrapp">
                  <span
                    class="d-flex align-items-center my-1"
                    *ngFor="let item of side_view?.breadcrumbs; let i = index"
                    [routerLink]="item?.routerLink"
                  >
                    <span class="custom-bredcrum-btn d-flex align-items-center">
                      <i
                        [hidden]="item?.image_sq"
                        class="{{ item?.icon }} me-1"
                      ></i>
                      <img
                        [hidden]="!item?.image_sq"
                        [src]="staticURL + item?.image_sq"
                        style="max-height: 1.2rem; max-width: 1.2rem"
                        class="blacknWhite img-fluid me-1"
                      />
                      {{ item?.label }}
                    </span>
                    <span class=""
                      ><i class="pi pi-fw pi-angle-left v4-bredcrum-icn"></i
                    ></span>
                  </span>
                </div> -->
                  <!-- breadcrumb end -->

                  <h4> <i class="pi pi-sitemap p-2" style="font-size: 1.2rem"></i>{{'Assigned Ous' | translator}}</h4>

                  <div class="d-flex flex-wrap">
                    <div *ngFor="let ou of side_view.ous" class="ouBread">
                      <div *ngIf="checkisImg(ou.image); else elseBlock" class="heading-imgg">
                        <img src="{{ staticURL }}{{ ou.image }}" class="img-fluid p-1 tree-img-v4" />
                      </div>
                      <ng-template #elseBlock>
                        <i class="{{ ou.image }} p-2" style="font-size: 1rem"></i>
                      </ng-template>
                      <span class="v4-color-white"> {{ou.name}} </span>
                    </div>
                  </div>


                  <h4> <i class="fa-solid pi-fw fa-chalkboard v4-ml-2" style="font-size: 1.2rem"></i>{{'Trainings' |
                    translator}}</h4>

                  <hr />

                  <p-accordion class="w-full v4-acordian-custom">
                    <p-accordionTab class="my-3 v4-acordian-custom"
                      *ngFor="let course of side_view?.courses let i = index" iconPos="end">
                      <ng-template class="v4-acordian-custom" pTemplate="header">
                        <div class="d-flex justify-content-between w-100">
                          <div class="d-flex align-items-center">
                            <!-- <i [ngClass]="field.label?.icon + ' font-1_2rem'" class="m-2"></i> -->
                            <div class="v4-icon-bg mx-2">
                              <img class="{{course.trainingId?.image ? 'toggle-img-2':'toggle-img'}}"
                                src="{{course?.trainingId?.image ? staticURL+course.trainingId?.image: '../../../assets/e-book.png'}}"
                                alt="loading..." />
                            </div>
                            <span class="vertical-align-middle font-1_1rem">{{ course?.trainingId?.title}}</span>
                          </div>
                          <div class="mob-mr d-flex">
                            <span class="tabel-circle-btn m-1">
                              <i pTooltip='{{"Edit"| translator}}' tooltipPosition="top" class="pi pi-file-edit"
                                (click)="openCourse(course?.trainingId?._id,'Edit')"></i>
                            </span>
                            <span class="tabel-circle-btn m-1">
                              <i pTooltip='{{"View"| translator}}' (click)="openCourse(course?.trainingId?._id,'View')"
                                tooltipPosition="top" class="pi pi-eye"></i>
                            </span>
                            <!-- <span class="mx-2">({{ log.createdAt | date }})</span> -->
                          </div>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="content">
                        <div class="container">
                          <!-- For View -->
                          <div class="col-12">
                            <span class="color-bold"><i class="pi pi-pencil mx-2"></i>{{ "Description" | translator
                              }}: </span>
                            <span [innerHTML]="course?.trainingId?.description"></span>
                          </div>

                          <!-- Sessions list dot ui end  -->
                          <app-training-timeline [sessions]="course?.trainingId?.sessions"></app-training-timeline>
                          <!--  Sessions list  dot ui end  -->
                          <hr>

                          <h4> <i class="pi pi-users v4-ml-2" style="font-size: 1.5rem"></i>{{'Users added in training'
                            | translator}}</h4>


                          <p-table [value]="course?.trainingId?.attendees" [paginator]="true"
                            [showCurrentPageReport]="true" [rows]="5">
                            <ng-template pTemplate="header" let-columns>
                              <tr>
                                <th>{{'user name' | translator}}</th>
                                <th>{{'Email' | translator}}</th>
                                <th>{{'Phone Number'}}</th>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-user let-columns="columns">
                              <tr>
                                <td>{{user?.name?.first}} {{user?.name?.middle}} {{user?.name?.last}}</td>
                                <td>{{user?.email}}</td>
                                <td>{{user?.phone}}</td>
                                <!-- <td>rao</td>
                              <td>usamailcom</td>
                              <td>08088237483</td> -->
                              </tr>
                            </ng-template>
                          </p-table>

                        </div>
                      </ng-template>
                    </p-accordionTab>
                  </p-accordion>

                  <h4 class="mt-2"> <i class="pi pi-users v4-ml-2" style="font-size: 1.5rem"></i>{{'Users added in training program' | translator}}</h4>
                  <p-table [value]="side_view.attendees" [paginator]="true" [showCurrentPageReport]="true" [rows]="5">
                    <ng-template pTemplate="header" let-columns>
                      <tr>
                        <th>{{'user name' | translator}}</th>
                        <th>{{'Email' | translator}}</th>
                        <th>{{'Phone Number'}}</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-user let-columns="columns">
                      <tr>
                        <td>{{user?.name?.first}} {{user?.name?.middle}} {{user?.name?.last}}</td>
                        <td>{{user?.email}}</td>
                        <td>{{user?.phone}}</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
          </div>
          <!-- End View Of the Service -->
        </div>
      </div>
    </ng-container>
    <!-- Training Content -->
    <!-- Add Training Program -->
    <div *ngIf="addTrainingProgram" class="container bg-rgb mb-3 p-3">
      <ng-container *ngIf="addTrainingProgram && !updateHolder">
        <app-add-training-program (closeForm)="closeProgramAddFrom($event)"></app-add-training-program>
      </ng-container>
      <ng-container *ngIf="addTrainingProgram && updateHolder">
        <app-add-training-program [programData]="updateHolder"
          (closeForm)="closeProgramAddFrom($event)"></app-add-training-program>
      </ng-container>
    </div>
    <!-- End Add Training Program -->

    <!-- </div> -->
  </div>
  <!-- Search Section -->
</section>
<!-- search section end -->

<p-toast></p-toast>

<!-- Confirm Modal -->
<p-confirmDialog #cd [style]="{ width: '50vw' }">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="pi pi-times" label="{{ 'cancellation' | translator }}"
      (click)="cd.reject()"></button>
    <button type="button" pButton icon="pi pi-check" label="{{ 'OK' | translator }}" (click)="cd.accept()"></button>
      </ng-template>
</p-confirmDialog>

<app-footer></app-footer>